// extracted by mini-css-extract-plugin
module.exports = {"modal":"PreviewPlan_modal__3L3OP","modalActive":"PreviewPlan_modalActive__31jms","loader":"PreviewPlan_loader__2DoW1","lds-ring":"PreviewPlan_lds-ring__2MkAc"};